// Iter 387 — Botón "Sincronizar con Alegra" de Regularización: anticipos entregados/recibidos + facturas abiertas.
import { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../../lib/api';
import { fmtFecha } from '../../../lib/utils';
import { Button } from '../../../components/ui/button';
import { RefreshCcw, Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';

export function SincronizarAlegraButton({ puedeAplicar, onDone }) {
  const [st, setSt] = useState({ running: false });
  const poll = useRef(null);
  const wasRunning = useRef(false);

  const loadStatus = useCallback(async () => {
    const r = await api.get('/contabilidad/regularizacion/sincronizar/status');
    setSt(r.data || { running: false });
    return r.data || {};
  }, []);
  useEffect(() => { loadStatus().catch(() => {}); }, [loadStatus]);

  useEffect(() => {
    if (st.running && !poll.current) {
      wasRunning.current = true;
      poll.current = setInterval(async () => {
        try {
          const s = await loadStatus();
          if (!s.running) {
            clearInterval(poll.current); poll.current = null;
            if (s.error) toast.error(`Sincronización con error: ${s.error}`); else toast.success('Sincronización con Alegra completada');
            onDone?.();
          }
        } catch { /* siguiente tick */ }
      }, 3000);
    }
    return () => { if (poll.current) { clearInterval(poll.current); poll.current = null; } };
  }, [st.running, loadStatus, onDone]);

  const iniciar = async () => {
    try {
      const r = await api.post('/contabilidad/regularizacion/sincronizar', { dias_back: 90 });
      if (r.data.started) { toast.info('Sincronizando con Alegra: anticipos entregados y recibidos, facturas de proveedores/honorarios y clientes…'); setSt({ running: true, fase: 'Iniciando…' }); }
      else toast.info('Ya hay una sincronización en curso');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo iniciar la sincronización');
    }
  };

  const r = st.resumen || {};
  const n = (o, k) => (o && typeof o[k] === 'number' ? o[k] : 0);
  return (
    <div className="flex flex-col items-end gap-1" data-testid="sync-alegra">
      <Button size="sm" onClick={iniciar} disabled={!puedeAplicar || st.running} className="bg-slate-800 hover:bg-slate-900" data-testid="btn-sincronizar-alegra" title="Revisa cuentas 5008 (anticipos entregados) y 5033 (anticipos recibidos), facturas de proveedores, honorarios y clientes">
        {st.running ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <RefreshCcw className="w-4 h-4 mr-1.5" />}
        {st.running ? 'Sincronizando…' : 'Sincronizar con Alegra'}
      </Button>
      {st.running && <span className="text-[11px] text-muted-foreground max-w-[420px] text-right" data-testid="sync-fase">{st.fase}</span>}
      {!st.running && st.error && <span className="text-[11px] text-red-700 flex items-center gap-1" data-testid="sync-error"><AlertTriangle className="w-3 h-3" /> {st.error}</span>}
      {!st.running && !st.error && st.last_run && (
        <span className="text-[11px] text-muted-foreground text-right max-w-[560px]" data-testid="sync-resumen" title={JSON.stringify(r)}>
          <CheckCircle2 className="w-3 h-3 inline text-emerald-600 mr-1" />
          Última sync {fmtFecha(st.last_run)}{st.run_by?.startsWith('automática') ? ' (automática 02:00)' : ''} · egresos +{n(r.egresos, 'insertados')}/{n(r.egresos, 'actualizados')} · ingresos +{n(r.ingresos, 'insertados')}/{n(r.ingresos, 'actualizados')} ·
          pendientes releídos {n(r.pendientes_egresos, 'leidos') + n(r.pendientes_ingresos, 'leidos')} ·
          facturas prov. {n(r.facturas_proveedores, 'abiertas_alegra')} abiertas ({n(r.facturas_proveedores, 'honorarios')} honorarios, {n(r.facturas_proveedores, 'cerradas_detectadas')} cerradas) ·
          clientes {n(r.facturas_clientes, 'abiertas_alegra')} abiertas ({n(r.facturas_clientes, 'cerradas_detectadas')} cerradas)
        </span>
      )}
    </div>
  );
}
